import { MessageCircle } from 'lucide-react';

function WhatsAppFloat() {
  const handleWhatsAppClick = () => {
    const number = process.env.REACT_APP_WHATSAPP_NUMBER || '50767541097';
    const message = encodeURIComponent(process.env.REACT_APP_WHATSAPP_MESSAGE || 'Hola, me interesa conocer más sobre tu trabajo fotográfico');
    window.open(`https://wa.me/${number}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
}

export default WhatsAppFloat;
